let env = {};

env.baseURL = 'https://api.ares-sign.it4d.com.br/api/v1/';
env.normalURL = 'https://api.ares-sign.it4d.com.br/';
env.mode = 'production';

// Configuração do Reverb consumida por src/bootstrap.js. Precisa bater com
// REVERB_HOST/REVERB_PORT/REVERB_SCHEME e REVERB_APP_KEY do .env da API.
// bootstrap.js referenciava env.webserviceHost/env.webservicePort, que nunca
// existiram aqui — por isso o Echo nunca conectou a nada.
env.reverbKey = 'hfag7tvkg0f3ebt6bhde';
env.reverbHost = 'localhost';
env.reverbPort = 8181;
env.reverbScheme = 'http';

export default env
